function changeIssuesTabCounter(delta: number) {
  const issuesTab = document.getElementById('issues-repo-tab-count')
  if (issuesTab === null) {
    return false
  }

  const currentCount = Number(issuesTab.title.replace(/\D/g, ''))
  const newCount = Math.max(currentCount + delta, 0)

  if (currentCount === 0 && newCount > 0) {
    // If the current count is 0 and we're incrementing, unhide the issues tab
    unhideIssuesTabCounter(issuesTab)
  } else if (newCount === 0) {
    // If the new count is 0, hide the issues tab
    hideIssuesTabCounter(issuesTab)
  }

  // Update the title with the new count
  issuesTab.title = newCount.toLocaleString()

  // Check if the text content is rounded (e.g., contains non-numeric characters like "1k")
  const isRounded = !/^\d*$/.test(issuesTab.textContent || '')

  // Update the text content based on the new count
  if (!isRounded && newCount <= 999) {
    issuesTab.textContent = newCount.toString()
  }

  return true
}

export function incrementIssuesTabCounter() {
  changeIssuesTabCounter(1)
}

export function decrementIssuesTabCounter() {
  changeIssuesTabCounter(-1)
}

function hideIssuesTabCounter(issuesTab: HTMLElement) {
  issuesTab.setAttribute('hidden', 'true')
}

function unhideIssuesTabCounter(issuesTab: HTMLElement) {
  issuesTab.removeAttribute('hidden')
}
